// removed by extract-text-webpack-plugin
module.exports = {"container":"xJYVMqfiE8pCM5hgJWJZ-","wrapper":"_3sdPqCFa5VnwvNEtGRbMVc","infoContainer":"_3Oq788QCGWqNppyjJ7bMsf","infoTitle":"_1ejXqxmYJ0bFJVTp8lS_s_","info":"_3FT1x9o8BmJshiPiPMwE-b","descWrapper":"_3TMbuJVANPIPaF0Cfq8GhR","description":"cvPiToUS2fLgHeM9Wi_8f","readMore":"_1UGGlhk49qZ4MOnDNhbGsH","map":"_3MINsr8FZtJdx2TDImZ3CJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Detail/MoreInfoDetailMobile.scss
// module id = 1129
// module chunks = 0